import VimeoComponent from "@components/Vimeo/VimeoComponent.vue";
import { Vue } from '@master';

const welcomePage = new Vue({
    el: '#welcome_page',
    mounted() {
        this.gaPageView();
    },
    components: {
        'vimeo': VimeoComponent
    }
});
